var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "popup",
      "duration": 500
    },
    on: {
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_vm.value ? _c('div', {
    staticClass: "vi-popup",
    class: (_class = {}, _class[_vm.popupClass] = true, _class['vi-popup-enter'] = _vm.isOpening, _class['vi-popup-leave'] = _vm.isClosing, _class)
  }, [_c('div', {
    staticClass: "background-blur",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }), _c('div', {
    staticClass: "popup-content-container"
  }, [_c('div', {
    staticClass: "close-popup",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/close-icon.svg")
    }
  })]), _c('div', {
    staticClass: "popup-content"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "back-button caps-medium",
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "26",
      "height": "16",
      "viewBox": "0 0 26 16",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M24.7257 8.70711C25.1162 8.31658 25.1162 7.68342 24.7257 7.2929L18.3617 0.928934C17.9712 0.538409 17.338 0.538409 16.9475 0.928934C16.557 1.31946 16.557 1.95262 16.9475 2.34315L22.6043 8L16.9475 13.6569C16.557 14.0474 16.557 14.6805 16.9475 15.0711C17.338 15.4616 17.9712 15.4616 18.3617 15.0711L24.7257 8.70711ZM0.0185546 9L24.0186 9L24.0186 7L0.0185548 7L0.0185546 9Z",
      "fill": "#1B1C1D"
    }
  })]), _vm._v(" BACK ")])])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }